import React, { forwardRef, useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import FadeUpWrapper from 'components/FadeUpWrapper';
import useWindowSize from 'hooks/useWindowSize';
import Feather from 'products/global/assets/img/home/feather.png';
import { SCREEN_SIZES } from 'style';
import Bg from './components/Bg';
import {
  Background,
  StyledHomeCountry,
  Title,
  Highlight,
  Description,
  UnderlineContainer,
  Underline,
  FeatherImg
} from './styled';

const HomeCountry = forwardRef((props, ref) => {
  const { width: windowWidth } = useWindowSize();
  const { ref: underlineRef, inView } = useInView({
    rootMargin:
      windowWidth < SCREEN_SIZES.tabletPortrait ? '0px' : `-${window.innerHeight * 0.2}px`
  });
  const [showUnderline, setShowUnderline] = useState(false);

  useEffect(() => {
    if (inView) {
      // only set this to true once -> animation only runs on first scroll down
      setShowUnderline(true);
    }
  }, [inView]);

  const underlineVariants = {
    visible: { scaleX: 1 },
    hidden: { scaleX: 0 }
  };

  return (
    <Background>
      <StyledHomeCountry ref={ref}>
        <Title>
          <FadeUpWrapper damping={50} mass={2} yDelta={40}>
            SafetyWing is <br />
            your <Highlight>home country</Highlight> <br />
            on the internet
          </FadeUpWrapper>
        </Title>
        <FadeUpWrapper damping={50} mass={2} yDelta={40}>
          <Description>
            We’re here to remove the role of geographical borders as a barrier to equal
            opportunities and{' '}
            <UnderlineContainer>
              freedom for everyone
              <Underline
                ref={underlineRef}
                variants={underlineVariants}
                animate={showUnderline ? 'visible' : 'hidden'}
                transition={{ type: 'spring', damping: 300, mass: 2 }}
              />
            </UnderlineContainer>
            .
          </Description>
        </FadeUpWrapper>
        <FeatherImg src={Feather} alt="feather" />
      </StyledHomeCountry>
      <Bg />
    </Background>
  );
});

export default HomeCountry;
